export default __webpack_public_path__ + "static/media/ms_whitepaper.38a152ac.png";